module.exports = __webpack_public_path__ + "static/media/life-medegefinancierd-door-de-eu-vertical.865d1c22.png";